import { Injectable } from '@angular/core';
import { CohortDO } from '../../../../../common/domain-model-dtos';
import { AdminContextService } from '../../../../../common/services/admin.context.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LifetimeRiskDepositThresholdDTO } from './lifetime-deposit-thresholds';
import { EDDCheckpointDTO } from '../affordability-settings/affordability-settings.model';

@Injectable({
  providedIn: 'root',
})
export class LifetimeDepositThresholdsService {
  private currentCohort: CohortDO;

  constructor(
    private adminContextService: AdminContextService,
    private http: HttpClient
  ) {
    this.adminContextService.getCohortWatcher().subscribe((cohort) => {
      this.currentCohort = cohort;
    });
  }

  public get(): Observable<LifetimeRiskDepositThresholdDTO[]> {
    return this.http.get<LifetimeRiskDepositThresholdDTO[]>(`/player-activity/api/lifetime-deposits/thresholds`, {
      params: { currency: this.currentCohort.currency.code },
    });
  }
}
